<template>
	<div
		type="button"
		:class="[
			'tab',
			cssClass,
			{ 'tab--active': active },
			{ 'tab--button': button },
			{ 'tab--inline': inline },
			{ 'tab--rotate': hoverEffect == 'rotate' }
		]"
	>
		<svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'snow'" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_547_10908)"><path d="M21.04 17.06l-2.35-1.36 1.87-.5c.53-.14.85-.69.71-1.22s-.69-.85-1.22-.71l-3.8 1.02-3.47-2 3.47-2 3.8 1.02c.09.02.17.03.26.03.44 0 .84-.29.96-.74a.994.994 0 00-.71-1.22l-1.87-.5 2.35-1.36c.48-.28.64-.89.37-1.37a1.01 1.01 0 00-1.37-.37l-2.35 1.36.5-1.87a.994.994 0 00-.71-1.22.994.994 0 00-1.22.71l-1.02 3.8-3.47 2V6.55l2.78-2.78a.996.996 0 10-1.41-1.41l-1.37 1.37V1c0-.55-.45-1-1-1s-1 .45-1 1v2.71L8.4 2.34a.996.996 0 10-1.41 1.41l2.78 2.78v4.01l-3.47-2-1.02-3.8c-.14-.53-.69-.85-1.22-.71s-.85.69-.71 1.22l.5 1.87L1.5 5.76c-.48-.28-1.09-.11-1.37.37S.02 7.22.5 7.5l2.35 1.36-1.87.5c-.53.14-.85.69-.71 1.22.12.45.52.74.96.74.09 0 .17-.01.26-.03l3.8-1.02 3.47 2-3.47 2-3.8-1.02a.994.994 0 00-1.22.71.99.99 0 00.71 1.22l1.87.5L.5 17.04c-.48.28-.64.89-.37 1.37.19.32.52.5.87.5.17 0 .34-.04.5-.13l2.35-1.36-.5 1.87a.994.994 0 00.97 1.25c.44 0 .84-.29.96-.74L6.3 16l3.47-2v4.01l-2.78 2.78A.996.996 0 108.4 22.2l1.37-1.37v2.71c0 .55.45 1 1 1s1-.45 1-1v-2.71l1.37 1.37c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-2.78-2.78V14l3.47 2 1.02 3.8c.12.45.52.74.96.74.09 0 .17-.01.26-.03.53-.14.85-.69.71-1.22l-.5-1.87 2.35 1.36c.16.09.33.13.5.13a1.002 1.002 0 00.5-1.87l-.01.02z" fill="#04BEFB"/></g><defs><clipPath id="clip0_547_10908"><path fill="#fff" d="M0 0h21.54v24.56H0z"/></clipPath></defs></svg>
		<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'sun'" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_547_10918)" fill="#04BEFB"><path d="M13 7c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zM5 13c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1zM25 12h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zM13 21c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1zM13 5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1zM5.93 18.66l-2.12 2.12a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l2.12-2.12a.996.996 0 10-1.41-1.41h-.01zM19.36 7.64c.26 0 .51-.1.71-.29l2.12-2.12a.996.996 0 10-1.41-1.41l-2.12 2.12a.996.996 0 00.71 1.7h-.01zM20.07 18.66a.996.996 0 10-1.41 1.41l2.12 2.12c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-2.12-2.12h-.01zM5.93 7.34c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41L5.23 3.81a.996.996 0 10-1.41 1.41l2.12 2.12h-.01z"/></g><defs><clipPath id="clip0_547_10918"><path fill="#fff" d="M0 0h26v26H0z"/></clipPath></defs></svg>
		<svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'calendar-view'" v-bind:svg-inline="''" v-bind:class="'icon non-active'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_2002_712)"><path d="M15 1.99h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v.99H6V1c0-.55-.45-1-1-1S4 .45 4 1v.99H3c-1.65 0-3 1.35-3 3v13c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-13c0-1.65-1.35-3-3-3zm-12 2h1V5c0 .55.45 1 1 1s1-.45 1-1V3.99h6V5c0 .55.45 1 1 1s1-.45 1-1V3.99h1c.55 0 1 .45 1 1V7H2V4.99c0-.55.45-1 1-1zm12 15H3c-.55 0-1-.45-1-1V9h14v8.99c0 .55-.45 1-1 1z"/><path d="M9 13.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM13 13.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM5 17.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM9 17.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"/></g><defs><clipPath id="clip0_2002_712"><path d="M0 0h18v20.99H0z"/></clipPath></defs></svg>
		<svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'calendar-view'" v-bind:svg-inline="''" v-bind:class="'icon active'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_2002_5204)"><path d="M15 1.99h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v.99H6V1c0-.55-.45-1-1-1S4 .45 4 1v.99H3c-1.65 0-3 1.35-3 3v13c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-13c0-1.65-1.35-3-3-3zm-12 2h1V5c0 .55.45 1 1 1s1-.45 1-1V3.99h6V5c0 .55.45 1 1 1s1-.45 1-1V3.99h1c.55 0 1 .45 1 1V7H2V4.99c0-.55.45-1 1-1zm12 15H3c-.55 0-1-.45-1-1V9h14v8.99c0 .55-.45 1-1 1z"/><path d="M9 13.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM13 13.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM5 17.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM9 17.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"/></g><defs><clipPath id="clip0_2002_5204"><path d="M0 0h18v20.99H0z"/></clipPath></defs></svg>
		<svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'period-view'" v-bind:svg-inline="''" v-bind:class="'icon non-active'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_2002_5201)"><path d="M15 1.99h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v.99H6V1c0-.55-.45-1-1-1S4 .45 4 1v.99H3c-1.65 0-3 1.35-3 3v13c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-13c0-1.65-1.35-3-3-3zm-12 2h1V5c0 .55.45 1 1 1s1-.45 1-1V3.99h6V5c0 .55.45 1 1 1s1-.45 1-1V3.99h1c.55 0 1 .45 1 1V7H2V4.99c0-.55.45-1 1-1zm12 15H3c-.55 0-1-.45-1-1V9h14v8.99c0 .55-.45 1-1 1z"/><path d="M10.74 11.39l-2.31 3.08-1.18-1.18a.996.996 0 10-1.41 1.41l2 2c.19.19.44.29.71.29h.07c.29-.02.55-.17.73-.4l3-4c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2h-.01z"/></g><defs><clipPath id="clip0_2002_5201"><path d="M0 0h18v20.99H0z"/></clipPath></defs></svg>
		<svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'period-view'" v-bind:svg-inline="''" v-bind:class="'icon active'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_2002_722)"><path d="M15 1.99h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v.99H6V1c0-.55-.45-1-1-1S4 .45 4 1v.99H3c-1.65 0-3 1.35-3 3v13c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-13c0-1.65-1.35-3-3-3zm-12 2h1V5c0 .55.45 1 1 1s1-.45 1-1V3.99h6V5c0 .55.45 1 1 1s1-.45 1-1V3.99h1c.55 0 1 .45 1 1V7H2V4.99c0-.55.45-1 1-1zm12 15H3c-.55 0-1-.45-1-1V9h14v8.99c0 .55-.45 1-1 1z"/><path d="M10.74 11.39l-2.31 3.08-1.18-1.18a.996.996 0 10-1.41 1.41l2 2c.19.19.44.29.71.29h.07c.29-.02.55-.17.73-.4l3-4c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2h-.01z"/></g><defs><clipPath id="clip0_2002_722"><path d="M0 0h18v20.99H0z"/></clipPath></defs></svg>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'Tab',
	props: {
		active: {
			type: Boolean,
			default: false
		},
		isDisable: {
			type: Boolean,
			default: false
		},
		button: {
			type: Boolean,
			default: false
		},
		inline: {
			type: Boolean,
			default: false
		},
		icon: {
			type: String,
			default: ''
		},
		hoverEffect: {
			type: String,
			default: ''
		},
		cssClass: {
			type: String,
			default: ''
		}
	},
	methods: {}
}
</script>

<style scoped lang="scss">
.tab {
	display: flex;
	justify-content: center;
	align-items: center;
	height: $input-field-height;
	border: none;
	background-color: rgba(0, 0, 0, 0);
	color: $colorPrimary5;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
	border-bottom: 2px solid rgba(0, 0, 0, 0);

	svg {
		display: inline-block;
		vertical-align: middle;
		width: 26px;
		height: 26px;

		&.active {
			display: none;
		}
	}

	&--active {
		border-bottom: 2px solid $colorSecondary;
		color: $colorPrimary8;

		svg {
			&.non-active {
				display: none;
			}
			&.active {
				display: inline-block;
			}
		}
	}
	&--button {
		border-bottom: 0;
		display: inline-flex;
		appearance: initial;
		-webkit-appearance: initial;
	}
	&--rotate {
		svg {
			transition: transform 400ms linear;
		}

		&:hover {
			svg {
				transform: rotate(-180deg);
			}
		}
	}
	&--inline {
		border-bottom: 0;
		display: inline-flex;
		appearance: initial;
		-webkit-appearance: initial;
		position: relative;

		font-size: 18px;
		line-height: 20px;
		font-weight: 400;
		color: #2a3e61;
		margin: 0 50px 40px 0;

		svg {
			fill: #546482;
			width: 24px;
			height: 24px;
			margin-right: 10px;
		}

		span {
			border-bottom: 1px solid #2a3e61;
		}

		&.tab--active {
			color: #000;

			span {
				border: none;
			}

			&:after {
				content: '';
				position: absolute;
				left: 0;
				bottom: -5px;
				width: 100%;
				height: 3px;
				background: #04befb;
			}

			svg {
				fill: #000;
			}
		}
	}

	&.disable {
		cursor: default;
		color: $colorPrimary2;
	}

	//Special classes
	&.accommodation-input-modal__tab-button {
		svg {
			fill: $colorPrimary6;
		}
		span {
			border-bottom: none;
		}

		&.tab--active {
			svg {
				fill: $colorPrimary9;
			}
		}
	}
}
</style>
